
export const extractRewardInfo = (reward: string | undefined) => {
  if (!reward) return { price: "", currency: "ILS" };
  const numericValue = reward.replace(/[^0-9.]/g, '');
  const currencySymbol = reward.replace(/[0-9.]/g, '').trim();
  const symbolToCode: { [key: string]: string } = {
    '₪': 'ILS',
    '$': 'USD',
    '€': 'EUR',
    '£': 'GBP'
  };
  return {
    price: numericValue,
    currency: symbolToCode[currencySymbol] || 'ILS'
  };
};
